import React from 'react'
import FontAwesome from 'react-fontawesome'

function addCondition() {
	const { values, setFieldValue, toastError } = this.props
	const { points, price: rawPrice, forSubscribers: rawForSubscribers } = values
	const forSubscribers = !!rawForSubscribers
	const price = (rawPrice + '').replace(',', '.')

	if (!points && !price) {
		toastError({ message: 'Condição de pagamento inválida' })
		return
	}

	const { paymentConditions } = this.state

	const duplicatedCondition = paymentConditions.some(
		item =>
			item.price == price &&
			item.points == points &&
			item.forSubscribers == forSubscribers
	)
	if (duplicatedCondition) {
		toastError({ message: 'Condição de pagamento duplicada' })
		return
	}

	const alreadyHasConditionWithNoValue =
		price == 0 &&
		paymentConditions.some(
			condition =>
				condition.forSubscribers == rawForSubscribers &&
				condition.price == 0
		)
	if (alreadyHasConditionWithNoValue) {
		toastError({
			message: `Já existe uma condição de pagamento apenas com pontos${
				rawForSubscribers ? ' para assinantes do clube' : ''
			}`
		})
		return
	}

	const previousCondition = paymentConditions
		.filter(condition => condition.forSubscribers == forSubscribers)
		.pop()
	const nextOrder = previousCondition ? previousCondition.order + 1 : 1

	const newCondition = {
		price,
		points,
		forSubscribers,
		order: nextOrder,
		id: 100 * forSubscribers + nextOrder
	}

	setFieldValue('points', 0)
	setFieldValue('price', 0)

	paymentConditions.push(newCondition)
	this.updateConditions(paymentConditions)
}

function removeCondition(conditionId) {
	const { paymentConditions } = this.state
	const condition = paymentConditions.find(({ id }) => conditionId == id)

	const newConditions = paymentConditions
		.filter(({ id }) => id != conditionId)
		.map(item => {
			if (
				item.forSubscribers == condition.forSubscribers &&
				item.order > condition.order
			) {
				item.id--
				item.order--
			}

			return item
		})

	this.updateConditions(newConditions)
}

function updateConditions(paymentConditions) {
	this.setState({ paymentConditions }, () => this.refs.pagination.reload())
}

function renderRow(rowData, headers) {
	const handleRowData = (cellData, key) => {
		switch (key) {
			case 'price':
				return Number(cellData).$toReais()

			case 'points':
				return Number(cellData).toLocaleString('pt-BR')

			case 'forSubscribers':
				return cellData ? 'Sim' : 'Não'

			case 'id':
				return (
					<span>
						{rowData.order == 1 ? null : (
							<FontAwesome
								name="arrow-circle-up"
								title={'Alterar ordem'}
								style={{ marginRight: '15px' }}
								onClick={() => this.changeOrder(rowData.id)}
							/>
						)}
						<FontAwesome
							name="trash"
							title={'Remover'}
							onClick={() => this.removeCondition(rowData.id)}
						/>
					</span>
				)

			default:
				return cellData
		}
	}

	return headers.map(({ key, align }) => (
		<td key={key} align={align}>
			<span title={rowData[key]}>{handleRowData(rowData[key], key)}</span>
		</td>
	))
}

function changeOrder(conditionId) {
	const { paymentConditions } = this.state

	const currentCondition = paymentConditions
		.map((_, index) => ((_.index = index), _))
		.find(({ id }) => conditionId == id)

	if (currentCondition.order <= 1) return

	const otherCondition = paymentConditions
		.map((_, index) => ((_.index = index), _))
		.find(
			({ forSubscribers, order }) =>
				currentCondition.order - 1 == order &&
				forSubscribers == currentCondition.forSubscribers
		)

	otherCondition.order++
	currentCondition.order--

	const tmp = paymentConditions[currentCondition.index]
	paymentConditions[currentCondition.index] =
		paymentConditions[otherCondition.index]
	paymentConditions[otherCondition.index] = tmp

	this.updateConditions(paymentConditions)
}

function getData() {
	const { paymentConditions } = this.state
	return Promise.resolve({
		rows: paymentConditions,
		totalRows: paymentConditions.length
	})
}

export {
	getData,
	renderRow,
	changeOrder,
	addCondition,
	removeCondition,
	updateConditions
}
